(function imageCounter(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState) {
    return;
  }

  const previousImageCounter = global.NewHomeSource.ImageCounter;
  const counterElement = global.document.querySelector('[data-full-image-viewer-role="image-counter"]');
  let elementsInCollection = null;

  /**
   * @public
   * render: renders the image counter.
   *
   * @param {object} data information that is needed to render the image counter.
   */
  function render(data) {
    let imageIndex = data.Index;
    const isVisible = global.NewHomeSource.FullImageViewer.Config.isCaptionBarVisible(data);

    if (imageIndex > elementsInCollection) {
      imageIndex = elementsInCollection;
    }

    if (isVisible) {
      counterElement.innerHTML = imageIndex + '/' + elementsInCollection;
    } else {
      counterElement.innerHTML = '';
    }
  }

  /**
  * @constructs NewHomeSource.ImageCounter
  */
  function ImageCounter() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  ImageCounter.update = function update(data, topic) {
    if (topic === 'onCollectionSet') {
      elementsInCollection = data.TotalImages;
    }

    if (topic === 'onImageSet') {
      requestAnimationFrame(render.bind(this, data));
    }
  };

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.ImageCounter to the previous script.
  */
  ImageCounter.noConflict = function noConflict() {
    global.NewHomeSource.ImageCounter = previousImageCounter;
    return ImageCounter;
  };

  global.NewHomeSource.FullImageViewerState.add('onCollectionSet', ImageCounter);
  global.NewHomeSource.FullImageViewerState.add('onImageSet', ImageCounter);
  global.NewHomeSource.ImageCounter = ImageCounter;
}(window));
